import { supabase } from "../../supabase/supabase";

/**
 * Headers for the dashboard's requests to the API server (CALL_SERVICE_URL): JSON plus the
 * signed-in user's Supabase access token. The API server checks the user is a member of the
 * assistant's organization (api_auth.py); clients such as Hirevox use an x-api-key instead.
 */
export async function apiServerHeaders(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
